import React from 'react';
import { Button, Header, Modal, Message } from 'semantic-ui-react';
import { FieldDiff } from './types';
import { DiffLabel, DiffList, DiffNew, DiffOld } from './styles';

type ConfirmInvoiceChangesModalProps = {
  open: boolean;
  diffs: FieldDiff[];
  isLoading: boolean;
  onBack: () => void;
  onConfirm: () => void;
};

const ConfirmInvoiceChangesModal = ({
  open,
  diffs,
  isLoading,
  onBack,
  onConfirm
}: ConfirmInvoiceChangesModalProps) => {
  return (
    <Modal open={open} onClose={onBack} size="small" closeOnDimmerClick={!isLoading}>
      <Header icon="warning sign" content="Confirmar alterações da fatura" />
      <Modal.Content scrolling>
        <Message info>
          Revise as alterações abaixo antes de confirmar. Somente os campos
          modificados são listados.
        </Message>

        {diffs.length === 0 ? (
          <Message warning>Nenhuma alteração detectada.</Message>
        ) : (
          <DiffList>
            {diffs.map(diff => (
              <li key={diff.key}>
                <DiffLabel>{diff.label}</DiffLabel>
                <DiffOld>{diff.oldValue}</DiffOld>
                <span aria-hidden>→ </span>
                <DiffNew>{diff.newValue}</DiffNew>
              </li>
            ))}
          </DiffList>
        )}
      </Modal.Content>
      <Modal.Actions>
        <Button disabled={isLoading} onClick={onBack}>
          Voltar e revisar
        </Button>
        <Button
          color="green"
          loading={isLoading}
          disabled={isLoading || diffs.length === 0}
          onClick={onConfirm}
        >
          Confirmar alterações
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ConfirmInvoiceChangesModal;
